export default __webpack_public_path__ + "static/redo-68ea99e0df7e3f1e3a7b36f65f8cbf32.png";